import React from 'react';
import ProfitReportComponent from '../../../Components/Report/ProfitReport';

export default function ProfitReport() {
    return (
        <div className='page-body'>
            <ProfitReportComponent />
        </div>
    );
}